(() => {
  if (window.lvIncludedAccessoriesReady) return;
  window.lvIncludedAccessoriesReady = true;

  const initialize = (root) => {
    if (root.dataset.lvAccessoriesReady === 'true') return;
    root.dataset.lvAccessoriesReady = 'true';

    const viewport = root.querySelector('[data-lv-accessories-viewport]');
    const previous = root.querySelector('[data-lv-accessories-prev]');
    const next = root.querySelector('[data-lv-accessories-next]');
    const progress = root.querySelector('[data-lv-accessories-progress]');
    if (!viewport || !previous || !next || !progress) return;

    const update = () => {
      const maximum = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const fractionVisible = Math.min(1, viewport.clientWidth / Math.max(viewport.scrollWidth, 1));
      const position = maximum ? viewport.scrollLeft / maximum : 0;
      const thumbWidth = fractionVisible * 100;

      progress.style.width = `${thumbWidth}%`;
      progress.style.left = `${position * (100 - thumbWidth)}%`;
      previous.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= maximum - 2;
      root.classList.toggle('lv-accessories--static', maximum <= 2);
    };

    const step = () => {
      const card = viewport.querySelector('.lv-accessories__card');
      const track = viewport.querySelector('.lv-accessories__track');
      if (!card || !track) return viewport.clientWidth * 0.8;
      return card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
    };

    previous.addEventListener('click', () => viewport.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => viewport.scrollBy({ left: step(), behavior: 'smooth' }));
    viewport.addEventListener('scroll', update, { passive: true });

    if ('ResizeObserver' in window) new ResizeObserver(update).observe(viewport);
    else window.addEventListener('resize', update);
    requestAnimationFrame(update);
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-lv-accessories]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
